<template>
    <h1>3D Map</h1>
</template>
<script>
export default {
    //life cycle hooks  
    beforeCreate(){},
    created(){},
    beforeMount(){},
    mounted(){},
    beforeUpdate(){},
    updated(){},
    beforeDestroy(){},
    destroyed(){},
    deactivated(){},
    activated(){}
}
</script>
<style scoped>

</style>
